import React from "react";
import bannerImg from "../../../assets/Images/products/banner.png";

const ProductBanner = () => {
  return (
    <section className="relative w-full h-[300px] md:h-[400px] overflow-hidden">
      
      {/* Background Image */}
      <img
        src={bannerImg}
        alt="Products"
        className="absolute inset-0 w-full h-full object-cover"
      />

      {/* Overlay */}
      <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-black/30 to-transparent"></div>

      {/* Content */}
      <div className="relative h-full max-w-7xl mx-auto px-4 sm:px-6 flex flex-col justify-end">
        
        <h1 className="text-white text-2xl md:text-4xl font-semibold">
          Our Products
        </h1>

        <p className="text-gray-200 text-sm md:text-base mb-6 mt-1 max-w-xl">
          Explore our premium quality products crafted to meet your needs.
        </p>

      </div>
    </section>
  );
};

export default ProductBanner;